// Typelizer digest 592d37a51269ae47ab6850e4c391ae6e
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/documents/:document_id/cash_discounts */
  create: (
    params: { documentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/documents/:document_id/cash_discounts', params, options),
    method: 'post',
  }),

  /** DELETE /c/:company_id/documents/:document_id/cash_discounts/:id */
  destroy: (
    params: { documentId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/c/:company_id/documents/:document_id/cash_discounts/:id', params, options),
    method: 'delete',
  }),
}
